export class BaseEntity {
  entityId: number;
}
